import React, { useState } from 'react';
import './Callback.css';

const Callback = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setIsOpen(false);
      setFormData({ name: '', phone: '' });
    }, 3000);
  };

  return (
    <>
      {/* Плавающая кнопка */}
      <button className="callback-btn" onClick={() => setIsOpen(true)}>
        <img 
          src="https://png.pngtree.com/png-vector/20251120/ourmid/pngtree-d-icon-of-male-call-center-operator-customer-service-with-headset-png-image_18010687.webp" 
          alt="Заказать звонок" 
          className="callback-icon"
        />
      </button>

      {/* Модальное окно */}
      {isOpen && (
        <div className="callback-overlay" onClick={() => setIsOpen(false)}>
          <div className="callback-modal" onClick={(e) => e.stopPropagation()}>
            <button className="callback-close" onClick={() => setIsOpen(false)}>
              &times;
            </button>
            <div className="callback-header">
              <h3>Обратный звонок</h3>
              <p>Оставьте свой номер телефона, и мы перезвоним вам в течение 15 минут</p>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="callback-form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Ваше имя"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="callback-form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="+7 (___) ___-__-__"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="callback-submit">
                Жду звонка
              </button>
              {submitted && (
                <p className="callback-success">
                  Спасибо! Мы перезвоним вам в ближайшее время.
                </p>
              )}
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Callback;
